import React, { useState } from "react";

import { Col, Container, Row, Button } from "reactstrap";
import Spinners from "Components/Common/Spinner";
import { useDeleteBranch, useGetBranchesSummary } from "hooks/useBranches";
import Breadcrumbs from "Components/Common/Breadcrumb";
import BranchShop from "./BranchShop";
import AddBranchModal from "./AddBranchModal";
import EditBranchModal from "./EditBranchModal";
import DeleteModal from "Components/Common/DeleteModal";

const Branches = () => {
  document.title = "Papermap | Branches";

  const { data, isLoading } = useGetBranchesSummary();
  const { mutate } = useDeleteBranch();

  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [editDetails, setEditDetails] = useState<any>(null);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [resource, setResource] = useState<any>(null);

  const toggleAddModal = () => setShowAddModal(!showAddModal);
  const toggleEditModal = () => setShowEditModal(!showEditModal);
  const handleEditClick = (data: any) => {
    setEditDetails(data);
    toggleEditModal();
  };

  const onClickDelete = (item: any) => {
    setResource(item);
    setDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (resource) {
      mutate(resource.id);
      setDeleteModal(false);
      setResource(null);
    }
  };

  return (
    <React.Fragment>
      <AddBranchModal isOpen={showAddModal} toggle={toggleAddModal} />
      <EditBranchModal
        isOpen={showEditModal}
        toggle={toggleEditModal}
        editDetails={editDetails}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteConfirm}
        onCloseClick={() => setDeleteModal(false)}
      />
      <EditBranchModal
        isOpen={showEditModal}
        toggle={toggleEditModal}
        editDetails={editDetails}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteConfirm}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Branches" breadcrumbItem="Branches" />
          <div className="d-flex justify-content-end">
            <Button
              color="success"
              onClick={toggleAddModal}
              className="btn-rounded mb-4"
            >
              Add New Branch
            </Button>
          </div>
          {isLoading ? (
            <Spinners />
          ) : (
            <>
              <Row className="g-3">
                {data?.map((branch) => (
                  <Col key={branch.id} sm="12" md="6" lg="4" xl="4">
                    <BranchShop
                      branch={branch}
                      onEditClick={() => handleEditClick(branch)}
                      onDeleteClick={() => onClickDelete(branch)}
                    />
                  </Col>
                ))}
              </Row>

              {/* <Row>
            <Col xs="12">
              <div className="text-center my-3">
                <Link to="#" className="text-success">
                  <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                  Load more
                </Link>
              </div>
            </Col>
          </Row> */}
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Branches;
